import type { TourDefinition } from '../types';
import { TOUR_IDS } from '../types';

export const organizationDetailTour: TourDefinition = {
  id: TOUR_IDS.ORGANIZATION_DETAIL,
  steps: [
    {
      target: '[data-tour="org-detail-header"]',
      titleKey: 'organizationDetail.welcome.title',
      contentKey: 'organizationDetail.welcome.content',
      placement: 'center',
      skipBeacon: true,
    },
    {
      target: '[data-tour="org-create-tournament"]',
      titleKey: 'organizationDetail.createTournament.title',
      contentKey: 'organizationDetail.createTournament.content',
      placement: 'top',
    },
    {
      target: '[data-tour="org-tournament-live"]',
      titleKey: 'organizationDetail.tournamentLive.title',
      contentKey: 'organizationDetail.tournamentLive.content',
      placement: 'bottom-start',
    },
    {
      target: '[data-tour="org-tournament-upcoming"]',
      titleKey: 'organizationDetail.tournamentUpcoming.title',
      contentKey: 'organizationDetail.tournamentUpcoming.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="org-tournament-draft"]',
      titleKey: 'organizationDetail.tournamentDraft.title',
      contentKey: 'organizationDetail.tournamentDraft.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="org-tournament-past"]',
      titleKey: 'organizationDetail.tournamentPast.title',
      contentKey: 'organizationDetail.tournamentPast.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="org-tournament-cancelled"]',
      titleKey: 'organizationDetail.tournamentCancelled.title',
      contentKey: 'organizationDetail.tournamentCancelled.content',
      placement: 'bottom-end',
    },
    {
      target: '[data-tour="org-owners-section"]',
      titleKey: 'organizationDetail.inviteOwners.title',
      contentKey: 'organizationDetail.inviteOwners.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="org-admins-section"]',
      titleKey: 'organizationDetail.inviteAdmins.title',
      contentKey: 'organizationDetail.inviteAdmins.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="org-social-tab"]',
      titleKey: 'organizationDetail.socialTab.title',
      contentKey: 'organizationDetail.socialTab.content',
      placement: 'bottom-start',
      switchTab: 'social',
    },
    {
      target: '[data-tour="org-social-panel"]',
      titleKey: 'organizationDetail.socialLinks.title',
      contentKey: 'organizationDetail.socialLinks.content',
      placement: 'bottom',
      switchTab: 'social',
    },
    {
      target: '[data-tour="org-sponsors-tab"]',
      titleKey: 'organizationDetail.sponsorsTab.title',
      contentKey: 'organizationDetail.sponsorsTab.content',
      placement: 'bottom-end',
      switchTab: 'sponsors',
    },
    {
      target: '[data-tour="org-sponsors-panel"]',
      titleKey: 'organizationDetail.sponsors.title',
      contentKey: 'organizationDetail.sponsors.content',
      placement: 'bottom',
      switchTab: 'sponsors',
    },
  ],
};
